import { Alert } from '@showroomjs/ui';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
export const ErrorFallback = (props) => {
    return (React.createElement(Alert, { variant: "error" }, props.error instanceof Error
        ? props.error.message
        : JSON.stringify(props.error)));
};
export const ErrorBound = (props) => (React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback }, props.children));
//# sourceMappingURL=error-fallback.js.map